/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More health calculators`)
};

const es_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más calculadoras de salud`)
};

const de_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Gesundheitsrechner`)
};

const nl_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer gezondheidsrekenmachines`)
};

const fr_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de calculateurs de santé`)
};

const it_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altri calcolatori di salute`)
};

const pt_br2_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais calculadoras de saúde`)
};

const pt_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais calculadoras de saúde`)
};

const ja_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他の健康計算機`)
};

const zh_bmi_related_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多健康计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_related_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_related_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_related_title", locale)
	if (locale === "en") return en_bmi_related_title(inputs)
	if (locale === "es") return es_bmi_related_title(inputs)
	if (locale === "de") return de_bmi_related_title(inputs)
	if (locale === "nl") return nl_bmi_related_title(inputs)
	if (locale === "fr") return fr_bmi_related_title(inputs)
	if (locale === "it") return it_bmi_related_title(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_related_title(inputs)
	if (locale === "pt") return pt_bmi_related_title(inputs)
	if (locale === "ja") return ja_bmi_related_title(inputs)
	return zh_bmi_related_title(inputs)
};